import { createContext, useContext } from 'react';

const PagesContext = createContext();

export const usePages = () => useContext(PagesContext);

export default PagesContext;
